import { useApi, createApiHook } from "../utils/apiUtils";

const useReactivateAssignappQuestionnaire = () => {
  const { apiPatch } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const reactivate = async (assignappQuestionnaireId) => {
    startLoading();
    const response = await apiPatch(`/assignapp_questionnaires/${assignappQuestionnaireId}/reactivate`, "Error al reactivar el cuestionario");
    setResponse(response);
    return response;
  };

  return { reactivate, data, error, loading };
};

export default useReactivateAssignappQuestionnaire;
